import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { formatPrice } from "@/helpers/transformation/price";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderSliderImages',
  props: {
    images: {
      type: Array,
      required: true,
    },
    selectedimage: {
      type: Object,
      required: true,
    },
    isSelectDesign: {
      type: Boolean,
      required: false,
    },
    isSelectFacade: {
      type: Boolean,
      required: false,
    },
    showPrice: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["onRequestQuote", "onSelectImage"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;
  const { isDesktop } = useIsDesktop(990);

  const displayedImages = ref([...props.images]);
  const builderCarousel = ref();

  const onSelectImage = (image: { id?: string; _id?: string }) => {
    const idComparison = props.isSelectDesign
      ? image?._id === props.selectedimage?._id
      : image?.id === props.selectedimage?.id;

    if (idComparison) {
      return;
    }

    emits("onSelectImage", image);
  };

  const handleScroll = () => {
    const viewportWidth = builderCarousel.value.clientWidth;
    const scrollLeft = builderCarousel.value.scrollLeft;
    const maxScroll = builderCarousel.value.scrollWidth - viewportWidth;
    const tolerance = 20;

    if (maxScroll - scrollLeft < viewportWidth / 2 + tolerance) {
      displayedImages.value = [...displayedImages.value, ...props.images];
    }
  };

  watch(
    () => props.images,
    (newVal) => {
      displayedImages.value = newVal;
    },
    { immediate: true, deep: true }
  );

const __returned__ = { props, emits, isDesktop, displayedImages, builderCarousel, onSelectImage, handleScroll, ref, watch, get useIsDesktop() { return useIsDesktop }, get formatPrice() { return formatPrice } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})